<template>
  <div id="wrapped">
    <div id="adress">
    <p v-lang.address></p></div>
    <div id="map"><iframe width="600" height="450" frameborder="0" style="border:0"
src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJzXqNkCMru0cRlWmBqfRPZGg&key=AIzaSyBL3vNfCCizPKuM87-M5e_1TIpI9_aH9Vw" allowfullscreen></iframe></div>
    <div id="pathdesc"><p id="path" v-lang.pathtitle></p>
<ul>
<li class="wing"><span v-lang.stepone></span></li>
<li class="wing"><span v-lang.steptwo></span></li>
<li class="wing"><span v-lang.stepthree></span></li>
<li class="wing"><span v-lang.stepfour></span></li>
<li class="wing"><span v-lang.stepfive></span></li></ul></div>
  </div>
</template>
<script>
export default {
  name: 'kontakt',
  data () {
    return {}
  },
  messages: {
    de: {
      address: 'Die schuett-biotec GmbH hat ihren Firmensitz in der Universitätsstadt Göttingen, Germany.\nschuett-biotec GmbH\nRudolf-Wissell-Straße 13\nD-37079 Göttingen\nGermany\n',
      pathtitle:'Anfahrtsbeschreibung:',
      stepone:'A7 Abfahrt 72 (Göttingen-Nord, Richtung Göttingen-Holtensen, Göttingen-Weende, Braunlage) auf die B27 fahren',
      steptwo:'Erste Abfahrt rechts / Richtung Holtensen - Industriegebiet',
      stepthree:'An der Ampel geradeaus in die Herrmann-Kolbe-Straße',
      stepfour:'Die erste Straße links einbiegen in die August-Spindler-Straße',
      stepfive:'Erneut die erste Straße links einbiegen in die Rudolf-Wissel-Straße'
    },
    en: {
      address: 'The schuett-biotec GmbH is located in the university town G&ouml;ttingen, Germany.\nschuett-biotec GmbH\nRudolf-Wissell-Straße 13\nD-37079 Göttingen\nGermany\n',
      pathtitle:'Directions:',
      stepone:'A7, Departure 72 (Göttingen-Nord towards Göttingen Holtensen, Göttingen-Weende, Braunlage) drive onto the B27.',
      steptwo:'At the first departure to the right move towards Holtensen-Industriegebiet.',
      stepthree:'At the traffic lights go straight on towards the Hermann-Kolbe-Straße.',
      stepfour:'At the first departure to the left enter the August-Spindler-Straße.',
      stepfive:'Again take the first departure to the left for the Rudolf-Wissell-Straße.'
    }
  }
}
</script>
<style scoped>
  #wrapped {
    display: grid;
    grid-template-rows: 25% auto;
    grid-template-columns: 50% 50%;
    grid-template-areas:
      "first first"
      "ifra desc";
  }
  #wrapped>*{
    padding: 10px;
  }
  #adress{
    grid-area: first;
  }
  #map{
    grid-area: ifra;
  }
  #pathdesc{
    grid-area: desc;
  }
  iframe {
    height: 500px;
    width: 100%;
  }
  p {
    color: #000;
    white-space: pre;
    text-align: left;
  }
  ul{
    list-style: none;
  }
  .wing {
    color: black;
    padding-left: -1em;
  }
  .wing:before{
    content: "•";
    color: red;
    padding-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/kontakt.vue